import { render, staticRenderFns } from "./makeAiStory.vue?vue&type=template&id=819105e8&scoped=true"
import script from "./makeAiStory.vue?vue&type=script&lang=js"
export * from "./makeAiStory.vue?vue&type=script&lang=js"
import style0 from "./makeAiStory.vue?vue&type=style&index=0&id=819105e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819105e8",
  null
  
)

export default component.exports